// Общие константы для донных сливов

export const DRAIN_AXIS = {
    LENGTH: 'length',
    WIDTH: 'width'
};

export const POOL_TYPES = {
    SKIMMER: 'скиммерный',
    OVERFLOW: 'переливной'
};

export const DRAIN_CONSTANTS = {
    TOOLTIP: {
        x: 0,
        y: 1.2,
        z: 0
    },
    CLICK_AREA: {
        BOX_GEOMETRY: [0.9, 0.1, 0.9],
        Y_OFFSET: 0.05,
        SPHERE_RADIUS: 0.15,
        SEARCH_RADIUS: 0.2
    },
    TOOLTIP_OFFSET: {
        Y: 1.2,
        X: 0,
        Z: 0
    },
    SPHERE_GEOMETRY: {
        RADIUS: 0.6,
        WIDTH_SEGMENTS: 1,
        HEIGHT_SEGMENTS: 1
    },
    POSITIONING: {
        VERTICAL_OFFSET: -0.05,
        /** Отступ донных сливов от стены чаши (м) — переливной и скиммерный */
        WALL_INSET_M: 0.2,
    }
};
